export default "__VITE_ASSET__BDir8dhf__"